
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		getProviderStatistics
	} from '@/api/supplier';
	import{
		getSearchDate
	}from "@/utils/index"

	@Component({
		name: 'supplier-statistics',
		components: {
			PageFooter, PickerDate
		}
	})
	export default class SupplierStatistics extends Vue {
		private supplierNameKey = ''
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0
		private filterTime:any = getSearchDate(1).join('/')

		private mounted() {
			
			// var dt = new Date();
			// var year = dt.getFullYear();
			// var month = dt.getMonth()+1;
			// var day = dt.getDate()
			// this.filterTime = [year, month, 1].join('-')+'/'+[year, month, day].join('-');
			// console.log(this.filterTime)
			
			this.getList();
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private doClear() {
			this.supplierNameKey = '';
			this.filterTime = getSearchDate(1).join('/')
			this.pageNo = 1;
			this.getList();
		}

		private toDetail(id: number) {
			
			let start = '';
			let end = '';
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				start = dt[0];
				end = dt[1] + ' 23:59:59';
			}
			
			this.$router.push({
				name: 'Supplier_Date_Detail',
				query: {
					id: id + '',
					start: start,
					end: end
				}
			})
		}

		// 获取列表
		private async getList() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				Keywords: this.supplierNameKey
			}

			if (this.filterTime){
				params.StartTime = this.filterTime.split('/')[0];
				params.EndTime = this.filterTime.split('/')[1] + ' 23:59:59'
			}

			try {
				const res: any = await getProviderStatistics(params);
				this.list = res.Result.Results;
				this.total = res.Result.Total;
			} catch (err) {
				console.error('getProviderStatistics ===>', err)
			}
		}

		private pageChange(num: number) {
			this.pageNo = num;
			this.getList();
		}

		private handleExport(){

			let start = '';
			let end = '';
			if (this.filterTime){
				start = this.filterTime.split('/')[0];
				end = this.filterTime.split('/')[1] + ' 23:59:59'
			}

			const url = `${location.origin}/pc/provider/sellStatis?Keywords=${this.supplierNameKey}&StartTime=${start}&EndTime=${end}`;
			window.open(url);
		}
	}
